import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { DataFieldModel } from '@fi-app/data-field/data-field.model';
import { BusinessUnitModel } from '@fi-app/business-unit/business-unit.model';
import { DataFieldHelperService } from '@fi-app/data-field/data-field-helper.service';
import { FiUserEditDataFieldEmailAddress_Settings } from '@fi-app/data-field/data-field-edit/email-address/email-address.component';
import {
    FiUserEditDataFieldPhoneNumber_Settings,
    TFiUserEditDataFieldPhoneNumber_Settings,
} from '@fi-app/data-field/data-field-edit/phone-number/phone-number.component';
import { FiUserEditDataFieldAddress_Settings } from '@fi-app/data-field/data-field-edit/address/address.component';
import { FiComponentsContainer } from '@fi-shared/fi-components-container';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';
import { DataFieldPropertyType } from '@fi-app/data-field/data-field-property-type';

@Component({
    selector: 'fi-business-unit-edit-location-and-contact-tab',
    templateUrl: './fi-business-unit-edit-location-and-contact-tab.component.html',
    styleUrls: ['./fi-business-unit-edit-location-and-contact-tab.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-business-unit-edit-location-and-contact-tab' },
    providers: [
        {
            provide: FiUserEditDataFieldEmailAddress_Settings,
            deps: [FiBusinessUnitEditLocationAndContactTabComponent],
            useFactory: () => {
                return {
                    isNewAddButtonLayout: true,
                };
            },
        },
        {
            provide: FiUserEditDataFieldPhoneNumber_Settings,
            useFactory: (): TFiUserEditDataFieldPhoneNumber_Settings => {
                return {
                    isCountryCodeNewLayout: true,
                    isNewAddButtonLayout: true,
                };
            },
        },
        {
            provide: FiUserEditDataFieldAddress_Settings,
            useFactory: () => {
                return {
                    isNewAddButtonLayout: true,
                };
            },
        },
        { provide: FiComponentsContainer, useExisting: FiBusinessUnitEditLocationAndContactTabComponent },
    ],
    standalone: false,
})
export class FiBusinessUnitEditLocationAndContactTabComponent extends FiComponentsContainer {
    @Input() dataFields: DataFieldModel[];
    @Input() businessUnit: BusinessUnitModel;
    DataFieldPropertyType = DataFieldPropertyType;

    constructor(
        private dataFieldHelperService: DataFieldHelperService,
        private detectDevicesService: DetectDevicesService,
    ) {
        super();
    }

    isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    getDataFieldByPropertyType(dataFieldPropertyType: DataFieldPropertyType): DataFieldModel[] {
        return this.dataFieldHelperService.getDataFieldsByPropertyTypes(this.dataFields, [dataFieldPropertyType]);
    }
}
